import React from "react";

const AboutSection = () => {
  return (
    <section className="font-serif text-gray-800 max-w-6xl mx-auto p-6">
      {/* About Us */}
      <div className="mb-12">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-4">
          About Us
        </h2>
        <p className="text-gray-600 leading-relaxed">
          Bunda Investment is a non-deposit microfinance institution whose core
          purpose is being the premier financial provider to small and medium
          size businesses, professionals and individuals. The company was
          founded in 2020. We specialize in vast loan products that are
          custom-made to suit your borrowing needs. We stand out as an
          establishment that delivers and provides unique financial solutions in
          a timely fashion at the customers’ earliest opportunity while
          considering the competitive conditions.
        </p>
      </div>

      {/* Vision & Mission */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
        <div>
          <h3 className="text-2xl font-semibold text-gray-800 mb-2">
            Our Vision
          </h3>
          <p className="text-gray-600 leading-relaxed">
            We aspire to become the independent financial company of choice for
            small and medium sized businesses, professional and individuals in
            Kenya.
          </p>
        </div>
        <div>
          <h3 className="text-2xl font-semibold text-gray-800 mb-2">
            Our Mission
          </h3>
          <p className="text-gray-600 leading-relaxed">
            To be the principal provider of financial solutions through
            accountability, transparency and building people’s trust in an
            amicable and professional manner.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
